import EditLandmarksSection from "./EditLandmarksSection";
import FunctionalButton from "components/layout/FunctionalButton";

import { ReactComponent as ArrowIcon } from "assets/svgs/Arrow.svg";

const EditLandmarksSidebar = ({
    visible = false,
    landmarks,
    selectedLandmark,
    setSelectedLandmark,
    toggleVisible = () => {},
}) => {
    const haveLandmarks = landmarks && Object.keys(landmarks).length > 0;
    return (
        <div className="relative h-full">
            <div
                className={`flex h-full flex-col items-start justify-start space-y-3 rounded-r5 bg-black80 ${
                    visible ? "mr-2 w-67 min-w-45 p-2 " : "invisible mr-0 w-0 p-0"
                }`}
            >
                <p className="text-h3">Landmarks</p>
                {haveLandmarks &&
                    Object.entries(landmarks).map(([landmarkType, landmarkInfos], id) => (
                        <EditLandmarksSection
                            key={id}
                            landmarkType={landmarkType}
                            landmarkInfos={landmarkInfos}
                            selectedLandmark={selectedLandmark}
                            onSelectLandmark={setSelectedLandmark}
                        />
                    ))}
            </div>
            <FunctionalButton
                className={`absolute top-1/2 z-10 h-9 w-3 -translate-y-1/2 transform rounded-r-r5 bg-black60 ${
                    visible ? "-right-1" : "-right-3"
                }`}
                icon={<ArrowIcon className={visible && "-rotate-180"} />}
                onClick={toggleVisible}
            />
        </div>
    );
};

export default EditLandmarksSidebar;
